module.exports = __webpack_public_path__ + "static/media/ethical_data_consultant.590f3df0.svg";